import InterislandRatePage from '../containers/Rate/Interisland/InterislandRate'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Express = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <InterislandRatePage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Express
